import type { IExercise } from '../exercises';

export const ARCHIVED_ABS_TEACHINGS: IExercise[] = [
  {
    "id": "home-side-plank-v2",
    "name": "侧支撑",
    "bodyPart": "abs",
    "equipment": "bodyweight",
    "subCategory": "core",
    "tips": ["核心收紧，控制动作节奏","全程保持稳定"],
    "sets": 3,
    "reps": "每侧30秒",
    "rpe": 8,
    "restSeconds": 60,
    "isBodyweight": true,
    "difficulty": "advanced",
    "targetMuscles": ["核心肌群","腹横肌"],
    "demoUrl": "/media/gifs/home-side-plank-v2",
    "videoUrl": "/media/videos/home-side-plank-v2",
  },
  {
    "id": "personal-s1-abs-oblique-stretch",
    "name": "腹肌加腹外斜肌拉伸",
    "bodyPart": "abs",
    "equipment": "bodyweight",
    "subCategory": "abs",
    "tips": ["侧屈幅度循序渐进","每侧保持30-60秒"],
    "sets": 2,
    "reps": "45秒",
    "rpe": 2,
    "restSeconds": 10,
    "isBodyweight": true,
    "isStretch": true,
    "isWarmup": true,
    "source": "私教版",
    "demoUrl": "/media/gifs/personal-s1-abs-oblique-stretch",
    "videoUrl": "/media/videos/personal-s1-abs-oblique-stretch",
  },
  {
    "id": "personal-s7-hanging-leg-raise",
    "name": "悬垂举腿",
    "bodyPart": "abs",
    "equipment": "bodyweight",
    "subCategory": "lower-abs",
    "tips": ["核心发力带动腿部抬起","不借力摆动"],
    "sets": 3,
    "reps": "12",
    "rpe": 8,
    "restSeconds": 60,
    "isBodyweight": true,
    "source": "私教版",
    "demoUrl": "/media/gifs/personal-s7-hanging-leg-raise",
    "videoUrl": "/media/videos/personal-s7-hanging-leg-raise",
  },
  {
    "id": "personal-s7-crunch",
    "name": "仰卧卷腹",
    "bodyPart": "abs",
    "equipment": "bodyweight",
    "subCategory": "upper-abs",
    "tips": ["肩胛骨离地即可","感受上腹收缩"],
    "sets": 3,
    "reps": "15",
    "rpe": 7,
    "restSeconds": 45,
    "isBodyweight": true,
    "source": "私教版",
    "demoUrl": "/media/gifs/personal-s7-crunch",
    "videoUrl": "/media/videos/personal-s7-crunch",
  },
  {
    "id": "personal-s7-ab-wheel",
    "name": "健腹轮",
    "bodyPart": "abs",
    "equipment": "ab-wheel",
    "subCategory": "core",
    "tips": ["核心全程收紧","不塌腰不弓背"],
    "sets": 3,
    "reps": "10",
    "rpe": 8,
    "restSeconds": 60,
    "isBodyweight": false,
    "source": "私教版",
    "demoUrl": "/media/gifs/personal-s7-ab-wheel",
    "videoUrl": "/media/videos/personal-s7-ab-wheel",
  },
  {
    "id": "fanjue-reverse-hyperextension-crunch",
    "name": "反向山羊挺身卷腹",
    "bodyPart": "abs",
    "equipment": "bodyweight",
    "subCategory": "lower-abs",
    "tips": ["下背部+下腹复合","控制幅度"],
    "sets": 3,
    "reps": "12-15",
    "rpe": 8,
    "restSeconds": 45,
    "isBodyweight": true,
    "demoUrl": "/media/gifs/fanjue-reverse-hyperextension-crunch",
    "videoUrl": "/media/videos/fanjue-reverse-hyperextension-crunch",
  },
  {
    "id": "fanjue-cable-crunch-kneeling",
    "name": "跪姿龙门架磕头",
    "bodyPart": "abs",
    "equipment": "cable",
    "subCategory": "upper-abs",
    "tips": ["绳索卷腹","上腹顶峰收缩"],
    "sets": 3,
    "reps": "12-15",
    "rpe": 8,
    "restSeconds": 45,
    "isBodyweight": false,
    "demoUrl": "/media/gifs/fanjue-cable-crunch-kneeling",
    "videoUrl": "/media/videos/fanjue-cable-crunch-kneeling",
  },
  {
    "id": "fanjue-copenhagen-plank",
    "name": "哥本哈根支撑",
    "bodyPart": "abs",
    "equipment": "bodyweight",
    "subCategory": "obliques",
    "tips": ["侧支撑变体","核心+内收肌"],
    "sets": 3,
    "reps": "12-15",
    "rpe": 8,
    "restSeconds": 45,
    "isBodyweight": true,
    "demoUrl": "/media/gifs/fanjue-copenhagen-plank",
    "videoUrl": "/media/videos/fanjue-copenhagen-plank",
  },
  {
    "id": "fanjue-cable-twist",
    "name": "龙门架旋转",
    "bodyPart": "abs",
    "equipment": "cable",
    "subCategory": "obliques",
    "tips": ["绳索伐木旋转","侧重腹斜肌"],
    "sets": 3,
    "reps": "12-15",
    "rpe": 8,
    "restSeconds": 45,
    "isBodyweight": false,
    "demoUrl": "/media/gifs/fanjue-cable-twist",
    "videoUrl": "/media/videos/fanjue-cable-twist",
  },
];
